<template>
  <div class="swiper-slide">
    <div
      :style="renderImage"
      class="swiper-lazy"
      :class="isClickable ? 'pointer' : ''"
      @click="onBannerClick"
    ></div>
  </div>
</template>

<script>
import bannerApi from '@/apis/banner';
import common from '@/utils/common';

export default {
  name: 'BannerItem',
  props: {
    banner: {
      type: Object,
      default: () => {},
    },
    width: {
      type: Number,
      required: true,
    },
  },
  computed: {
    renderImage() {
      if (this.width < 600) {
        return `background-image:url(${this.banner.mobileImageUrl})`;
      }
      return `background-image:url(${this.banner.pcImageUrl})`;
    },
    isClickable() {
      return this.banner.linkTargetType.code !== 'NONE';
    },
  },
  methods: {
    async onBannerClick() {
      if (this.banner.linkTargetType.code === 'NONE') {
        return;
      }
      await bannerApi.updateBannerReadCount(this.banner.bannerId);
      common.moveToUrlOfTargetType(this, this.banner.linkTargetType.code, this.banner.linkUrl);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
